import React, { Component } from 'react';
import {connect} from 'react-redux';
import {actions, Form, Control} from 'react-redux-form';
import {Col, Row, FormGroup, Checkbox} from 'react-bootstrap';
import RequiredSelect from '../../../../common/form/elements/required-select';
import RequiredMultiSelect from '../../../../common/form/elements/required-multi-select';
import ImageUpload from '../../../../common/form/elements/image-upload';
import RequiredInput from '../../../../common/form/elements/required-input';
import TextInput from '../../../../common/form/elements/text-input';
import ColorPicker from '../../../../common/form/elements/color-picker';
import ArrowButton from '../../../../common/button-arrow';
import {saveBrand, updateBrand} from '../../../../../actions/brands';

class EditBrandForm extends Component {
  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.admin_brand'));
  }

  onSubmit = (payload) => {
    const { dispatch, brand: { id }} = this.props;

    if (id) {
      dispatch(actions.submitFields('deep.admin_brand', updateBrand(id, payload)));
    } else {
      dispatch(actions.submitFields('deep.admin_brand', saveBrand(payload)));
    }
  };

  render() {
    const {
      brand, categories, statuses, selectedCategories, formValid
    } = this.props;
    const sizeLimit = 1024 * 1024;

    let image;
    let banner;
    let mobileImage;
    let porImage;
    let bannerTextColour;
    let homepageBanner;

    if (brand) {
      const { attributes } = brand;
      image = attributes.links ? attributes.links.image : undefined;
      banner = attributes.links ? attributes.links.banner : undefined;
      porImage = attributes.links ? attributes.links['por-image'] : undefined;
      mobileImage = attributes.links ? attributes.links['mobile-image'] : undefined;
      bannerTextColour = attributes['banner-text-colour'];
      homepageBanner = attributes['homepage-banner'];
    }

    return (
      <Form model="deep.admin_brand" onSubmit={this.onSubmit}>
        <Row>
          <Col lg={12}>
            <RequiredInput
              controlId='name'
              label="Name"
              model='.name'
              placeholder="Name"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ImageUpload
              model=".photo"
              required
              sizeLimit={sizeLimit}
              source={image}
              type={['image/png', 'image/jpg', 'image/jpeg']}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ImageUpload
              model=".mobile_image"
              label="Upload a mobile image"
              sizeLimit={sizeLimit}
              source={mobileImage}
              type={['image/png', 'image/jpg', 'image/jpeg']}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredMultiSelect
              controlId="brandCategory"
              data={categories.map(category => ({
                id: category.id,
                name: category.attributes.name
              }))}
              label="Categories"
              labelAttr="name"
              model='deep.admin_brand.categories'
              value={selectedCategories}
              valueAttr="id"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredSelect
              controlId="brandCategory"
              label="Status"
              model=".status"
              values={statuses}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ImageUpload
              label="Banner image"
              source={banner}
              sizeLimit={1024 * 1024}
              type={['image/png', 'image/jpg', 'image/jpeg']}
              model=".banner"
              required
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <FormGroup controlId="bannerTextColour">
              <ColorPicker
                model="deep.admin_brand.banner_text_colour"
                textModel="deep.admin_brand.banner_text_colour"
                name="deep.admin_brand.banner_text_colour"
                textName="deep.admin_brand.banner_text_colour"
                label="Banner text colour"
                defaultColor={bannerTextColour == null ? 'Red' : bannerTextColour}
                defaultTextColor={bannerTextColour}
                backgroundColorPicker={false}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TextInput label="Banner title" model=".banner_title" controlId="bannerTitle" />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TextInput label="Banner text" model=".banner_text" controlId="bannerText" />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TextInput label="Banner button text" model=".banner_button_text" controlId="bannerButtonText" />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TextInput label="Banner URL" model=".banner_button_url" controlId="bannerButtonURL" />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Control.checkbox
              model=".homepage_banner"
              component={Checkbox}
              disabled={Boolean(homepageBanner)}
            >
              Homepage banner
            </Control.checkbox>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Control.checkbox model=".focus_brand" component={Checkbox}>
              Focus brand
            </Control.checkbox>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ImageUpload
              label="Upload a POR Image"
              source={porImage}
              sizeLimit={1024 * 1024}
              type={['image/png', 'image/jpg', 'image/jpeg']}
              model=".por_image"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrowButton
              className="pull-right"
              color="grey"
              disabled={!formValid}
            >
              Save
            </ArrowButton>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  statuses: state.brands.editorInput.statuses || [],
  categories: state.brands.editorInput.categories || [],
  selectedCategories: state.deep.admin_brand.categories,
  formValid: state.deep.forms.admin_brand.$form.valid
});

export default connect(mapStateToProps)(EditBrandForm);



// WEBPACK FOOTER //
// ./src/components/admin/products/brands/edit/brand-edit-form.jsx